import { Modal } from './Modal'
import type { ChapterItem } from './StoryNav'
import graphicLockSvg from '../svg/graphic-lock.svg?raw'
import track, { SELECT_CHAPTER } from '../features/analytics'

/** Modal "Kapitoly": ordered list of chapters. Revealed show title and are clickable (scroll, modal stays open); locked show lock icon. */
export class ChaptersModal {
  constructor(
    private modal: Modal,
    private getChapters: () => ChapterItem[],
    private getRevealedIndices: () => number[],
    private scrollToChapter: (index: number) => void,
  ) {}

  show(): void {
    const chapters = this.getChapters()
    const revealed = new Set(this.getRevealedIndices())

    this.modal.show(
      (dialog) => {
        dialog.appendChild(Modal.createHeader('Kapitoly', () => this.modal.hide()))
        const content = Modal.createContent()

        const list = document.createElement('ol')
        list.className = 'chapters-list'
        chapters.forEach((ch, i) => {
          const li = document.createElement('li')
          li.className = 'chapters-item'
          const btn = document.createElement('button')
          btn.type = 'button'
          btn.className = 'chapters-button'
          if (revealed.has(i)) {
            btn.textContent = ch.title
            btn.addEventListener('click', () => {
              track(SELECT_CHAPTER, ch.id)
              this.scrollToChapter(i)
            })
          } else {
            btn.classList.add('chapters-button--locked')
            btn.setAttribute('aria-disabled', 'true')
            const span = document.createElement('span')
            span.className = 'chapters-button-inner'
            const lock = document.createElement('span')
            lock.className = 'chapters-lock'
            lock.innerHTML = graphicLockSvg
            span.appendChild(lock)
            btn.appendChild(span)
          }
          li.appendChild(btn)
          list.appendChild(li)
        })
        content.appendChild(list)
        dialog.appendChild(content)
      },
      { lenisPrevent: true, bodyScrollLock: true },
    )
  }
}
